import { SOCIALS } from "@/data/portfolio";
import { Instagram, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#000000] pt-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 pb-12">
          <div className="col-span-12 md:col-span-6">
            <p className="font-oswald uppercase text-xs tracking-widest text-white/40">Post-production · Worldwide</p>
            <p className="mt-3 font-manrope text-base md:text-lg text-white/80 max-w-md leading-relaxed">
              Clean, engaging, platform-ready edits for the creators defining the reaction-content era.
            </p>
          </div>
          <div className="col-span-12 md:col-span-3">
            <p className="font-oswald uppercase text-xs tracking-widest text-white/40 mb-4">Connect</p>
            <a href="mailto:team@dotmkvmedia.com?subject=Project%20Inquiry%20-%20dotMKV%20Media" data-testid="footer-email" className="flex items-center gap-2 text-white hover:text-[#00A0E4] transition-colors mb-3 text-sm font-oswald uppercase tracking-wide">
              team@dotmkvmedia.com
            </a>
            <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="flex items-center gap-2 text-white hover:text-[#00A0E4] transition-colors mb-3">
              <Instagram size={16} /> Instagram
            </a>
            <a href={SOCIALS.x} target="_blank" rel="noopener noreferrer" data-testid="footer-x" className="flex items-center gap-2 text-white hover:text-[#00A0E4] transition-colors">
              <Twitter size={16} /> X / Twitter
            </a>
          </div>
          <div className="col-span-6 md:col-span-3">
            <p className="font-oswald uppercase text-xs tracking-widest text-white/40 mb-4">Inquiries</p>
            <a
              data-testid="footer-cta"
              href="https://cal.com/dotmkv-media-sgkgdp/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-[#00A0E4] transition-colors text-left block mb-3"
            >
              Book a discovery call →
            </a>
            <a
              data-testid="footer-email-cta"
              href="mailto:team@dotmkvmedia.com?subject=Project%20Inquiry%20-%20dotMKV%20Media"
              className="text-white/60 hover:text-[#00A0E4] transition-colors text-left block text-sm"
            >
              Or email us →
            </a>
          </div>
        </div>

        {/* Bottom bar */}

        <div className="border-t border-white/10 py-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40 uppercase tracking-widest font-oswald">
          <p>© {new Date().getFullYear()} dotMKV Media. All rights reserved.</p>
          <p>Built for creators who care about the cut.</p>
        </div>
      </div>
    </footer>
  );
}
